module.exports = __webpack_public_path__ + "files/e2c315a41c854a650c99255da1c2e970.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/video.svg
// module id = 582
// module chunks = 27